(function(){
  'use strict';

  var cfg=window.LMP_APP_CONFIG||{};

  function h(v){
    if(typeof window.esc==='function')return window.esc(v);
    return String(v==null?'':v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function u(path,extra){
    return (typeof window.appUrl==='function')?window.appUrl(path,extra):(path+(extra?((path.indexOf('?')>-1?'&':'?')+extra):''));
  }
  function normImg(src){
    if(!src)return'';
    if(typeof src==='object')src=src.src||src.url||'';
    src=String(src);
    return src.indexOf('//')===0?'https:'+src:src;
  }
  function money(v){
    if(typeof window.formatMoney==='function')return window.formatMoney(v);
    var n=parseFloat(v||0);return isNaN(n)?'':n.toFixed(2)+' DH';
  }
  function resultRow(p){
    var src=normImg(p.image||p.featured_image||'');
    var href=p.url||('/products/'+(p.handle||''));
    var price=p.price==null?'':(typeof p.price==='number'?money(p.price):h(String(p.price)));
    return '<a class="lmp-search-result" href="'+h(u(href))+'" data-lmp-link>'+
      (src?'<img src="'+h(src)+'" alt="'+h(p.title||'')+'" loading="lazy">':'<div></div>')+
      '<div><div class="lmp-search-result__vendor">'+h(p.vendor||'La Maison Para')+'</div><div class="lmp-search-result__title">'+h(p.title||'')+'</div><small>Voir le produit</small></div>'+
      '<div class="lmp-search-result__price">'+price+'</div></a>';
  }
  function empty(msg,sub){return '<div class="lmp-empty"><strong>'+h(msg)+'</strong>'+h(sub||'')+'</div>';}

  function predictive(q){
    var el=document.getElementById('lmp-search-results');if(!el)return;
    if(q.length<2){el.innerHTML=empty('Continuez à écrire','Entrez au moins 2 caractères.');return;}
    el.innerHTML=typeof window.skeleton==='function'?window.skeleton():'';
    var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=last&_='+Date.now();
    fetch(url,{credentials:'same-origin',headers:{'Accept':'application/json','Cache-Control':'no-cache'}})
      .then(function(r){if(!r.ok)throw new Error('search');return r.json();})
      .then(function(data){
        var all=((((data||{}).resources||{}).results||{}).products)||[];
        if(!all.length){el.innerHTML=empty('Aucun résultat','Essayez un autre nom de produit ou une marque.');return;}
        var ps=all.slice(0,6);
        var more='<a class="lmp-search-more" href="'+h(u('/search','q='+encodeURIComponent(q)+'&type=product&lmp_all=1'))+'" data-lmp-link><span>Voir tous les produits</span><b>→</b></a>';
        el.innerHTML='<div class="lmp-search-list">'+ps.map(resultRow).join('')+'</div>'+more;
        if(typeof window.lmpMarkDataFresh==='function')window.lmpMarkDataFresh();
      })
      .catch(function(){el.innerHTML=empty('Recherche indisponible','Réessayez dans quelques instants.');});
  }

  function normalizeFullProduct(p){
    return {
      title:p.title||'',vendor:p.vendor||'',handle:p.handle||'',url:p.url||('/products/'+(p.handle||'')),
      image:normImg(p.image||''),price:parseFloat(p.price||0)||0,compareAtPrice:parseFloat(p.compareAtPrice||0)||0,available:p.available!==false
    };
  }
  function fullCard(p){
    p=normalizeFullProduct(p);
    return (typeof window.productCard==='function')?window.productCard(p,true):resultRow(p);
  }
  function renderFullData(q,data,append){
    var el=document.getElementById('lmp-search-results');if(!el)return;
    var products=(data&&data.products)||[];
    var count=Number((data&&data.count)||products.length||0);
    var page=Number((data&&data.page)||1),pages=Number((data&&data.pages)||1);
    if(!products.length && !append){el.innerHTML=empty('Aucun résultat','Aucun produit trouvé pour « '+q+' ».');return;}
    var cards=products.map(fullCard).join('');
    if(!append){
      el.innerHTML='<div class="lmp-full-search-meta"><strong>'+count+' produit'+(count>1?'s':'')+'</strong><span>pour « '+h(q)+' »</span></div><div class="lmp-products lmp-full-search-grid" id="lmp-full-search-grid">'+cards+'</div><div id="lmp-full-search-more"></div>';
    }else{
      var grid=document.getElementById('lmp-full-search-grid');if(grid)grid.insertAdjacentHTML('beforeend',cards);
    }
    var more=document.getElementById('lmp-full-search-more');
    if(more){
      more.innerHTML=page<pages?'<button type="button" class="lmp-full-search-more" data-lmp-load-more data-page="'+(page+1)+'">Afficher plus</button>':'';
      var btn=more.querySelector('[data-lmp-load-more]');
      if(btn)btn.addEventListener('click',function(){btn.disabled=true;btn.textContent='Chargement…';loadFull(q,Number(btn.getAttribute('data-page')||2),true);});
    }
    if(typeof window.lmpMarkDataFresh==='function')window.lmpMarkDataFresh();
  }
  function fallbackFull(q){
    var el=document.getElementById('lmp-search-results');if(!el)return;
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&_='+Date.now(),{credentials:'same-origin',headers:{'Accept':'application/json','Cache-Control':'no-cache'}})
      .then(function(r){if(!r.ok)throw new Error('fallback');return r.json();})
      .then(function(data){
        var all=((((data||{}).resources||{}).results||{}).products)||[];
        if(!all.length){el.innerHTML=empty('Aucun résultat','Essayez un autre nom de produit ou une marque.');return;}
        el.innerHTML='<div class="lmp-full-search-meta"><strong>Résultats</strong><span>pour « '+h(q)+' »</span></div><div class="lmp-search-list">'+all.map(resultRow).join('')+'</div>';
      })
      .catch(function(){el.innerHTML=empty('Recherche indisponible','Réessayez dans quelques instants.');});
  }
  function loadFull(q,page,append){
    var el=document.getElementById('lmp-search-results');if(!el)return;
    if(!append)el.innerHTML=typeof window.skeleton==='function'?window.skeleton():'';
    var extra='q='+encodeURIComponent(q)+'&type=product&view=lmp&page='+encodeURIComponent(page||1);
    fetch(u('/search',extra),{credentials:'same-origin',headers:{'Accept':'application/json','Cache-Control':'no-cache'}})
      .then(function(r){if(!r.ok)throw new Error('full search');return r.text();})
      .then(function(txt){var data=JSON.parse(txt);renderFullData(q,data,append);})
      .catch(function(){if(!append)fallbackFull(q);else{var more=document.getElementById('lmp-full-search-more');if(more)more.innerHTML='<button type="button" class="lmp-full-search-more" data-lmp-retry>Réessayer</button>';var b=more&&more.querySelector('[data-lmp-retry]');if(b)b.addEventListener('click',function(){loadFull(q,page,true);});}});
  }

  window.renderSearch=function(){
    var params=new URLSearchParams(location.search||'');
    var q=params.get('q')||'';
    var all=params.get('lmp_all')==='1';
    var subtitle=(all&&q)?'Tous les résultats dans l’application':'Trouvez rapidement votre produit';
    var content=topbar(false)+'<div class="lmp-page-head"><div class="lmp-page-head__copy"><h1 class="lmp-page-title">Recherche</h1><small>'+h(subtitle)+'</small></div></div>'+searchBox(q)+'<div class="lmp-search-chips"><button type="button" data-lmp-quick-search="CeraVe">CeraVe</button><button type="button" data-lmp-quick-search="La Roche Posay">La Roche-Posay</button><button type="button" data-lmp-quick-search="Solaire">Solaire</button></div><div class="lmp-search-results" id="lmp-search-results">'+(q?(typeof window.skeleton==='function'?window.skeleton():''):empty('Que recherchez-vous ?','Produit, marque ou soin : commencez à écrire ci-dessus.'))+'</div>';
    shell(content);
    var input=document.querySelector('[data-lmp-search-form] input');
    if(input){
      var t=null;
      input.addEventListener('input',function(){clearTimeout(t);t=setTimeout(function(){window.runSearch(input.value,false);},260);});
      input.addEventListener('keydown',function(ev){if(ev.key==='Enter'){ev.preventDefault();window.runSearch(input.value,true);}});
    }
    document.querySelectorAll('[data-lmp-quick-search]').forEach(function(btn){btn.addEventListener('click',function(){if(input){input.value=btn.getAttribute('data-lmp-quick-search');window.runSearch(input.value,false);}});});
    if(q)window.runSearch(q,all);
  };

  window.runSearch=function(q,all){
    q=String(q||'').trim();
    if(q.length<2){var el=document.getElementById('lmp-search-results');if(el)el.innerHTML=empty('Continuez à écrire','Entrez au moins 2 caractères.');return;}
    if(all)loadFull(q,1,false);else predictive(q);
  };
})();
